@if (providerLogo) {
  <img [src]="providerLogo" />
} @else {
  @if (providerTitle) {
    <h2>{{ providerTitle }}</h2>
  } @else {
    <mat-icon class="lad-icon" [svgIcon]="ladLogo"></mat-icon>
  }
}
